/**
 * Created by Administrador on 20/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('generalDiscounts', {
                parent: 'app',
                url: '/generalDiscounts',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/generalDiscount/generalDiscounts.html',
                        controller: 'generalDiscountCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalDiscount']);
                            }],
                            generalDiscounts: ['generalDiscountService', function (generalDiscountService) {
                                return generalDiscountService.getGeneralDiscountList();
                            }]
                        }
                    }
                }
            })
            .state('generalDiscountNew', {
                parent: 'app',
                url: '/generalDiscount/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/generalDiscount/newGeneralDiscount.html',
                        controller: 'newEditGeneralDiscountCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('generalDiscounts')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalDiscount']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            generalDiscount: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('generalDiscountDelete', {
                parent: 'generalDiscounts',
                url: '/generalDiscount/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/generalDiscount/deleteGeneralDiscount.html',
                        controller: 'deleteGeneralDiscountCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            generalDiscount: ['generalDiscountService', function (generalDiscountService) {
                                return generalDiscountService.getGeneralDiscount($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalDiscount']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('generalDiscounts', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
